import Transactions from '../Components/Transactions';

function Index() {
  return (
    <div>
      <Transactions />
    </div>
  );
}

export default Index;